import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterSliceState, ScreenFilterState } from "./filterTypes";

const initialState: FilterSliceState = {
  savedFilters: {},
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    saveFilters(
      state,
      action: PayloadAction<{ screenKey: string; filters: ScreenFilterState }>
    ) {
      const { screenKey, filters } = action.payload;
      state.savedFilters[screenKey] = filters;
    },
    clearFilters(state, action: PayloadAction<string>) {
      const screenKey = action.payload;
      const existing = state.savedFilters[screenKey];
      if (existing) {
        const { paginationLimit, paginationPage } = existing;
        delete state.savedFilters[screenKey];
        if (paginationLimit !== undefined) {
          state.savedFilters[screenKey] = {
            paginationLimit,
            paginationPage,
          } as ScreenFilterState;
        }
      } else {
        delete state.savedFilters[screenKey];
      }
    },
    clearAllFilters(state) {
      state.savedFilters = {};
    },
  },
});

export const { saveFilters, clearFilters, clearAllFilters } =
  filterSlice.actions;
export default filterSlice.reducer;
